import { Feature } from "util/stdtypes";
import { InstanceManager, InstanceManagerConfig, NewInstance } from 'feature/editorial-dash/question-topic-manager';
import { ListBulleted } from "@carbon/icons-react";
import { Datastore, useServerCallResult } from "util/datastore";
import { LoadingScreen } from "component/banner";
import { urlToKey } from "util/util";
import { EditorialDashConfig } from "structure/editorial-dash";

export const ArticleManagerFeature : Feature<EditorialDashConfig & InstanceManagerConfig, {}> = {
    key: 'article-manager',
    name: 'Article Manager',
    config: {
        dashboardTabs: [
            {
                key: 'articles',
                label: 'Articles',
                icon: ListBulleted,
                component: ArticleManager
            },
        ],
        newInstanceCreators: [{
            structureKey: 'article',
            creator: async (datastore: Datastore, newInstance: NewInstance) => {
                const encodedKey = urlToKey(newInstance.name);
                return {key: encodedKey};
            }
        }]
    }
}

export function ArticleManager() {
    const articles = useServerCallResult('article', 'getArticleList')
    if(!articles) return <LoadingScreen />

    const articleObjects = articles.map(a=>({
        key: a,
        name: a,
        from: null
    }))
    return <InstanceManager titleLabel='Articles' instanceList={articleObjects} structureKey='article' />
}